export default [
  {
    path: "/platformConfigurations",
    component: () => import(/* webpackChunkName: "layout" */ "./layout"),

    children: [
      {
        path: "generalSettings",
        name: "platform.generalSettings",
        component: () =>
          import(/* webpackChunkName: "platform.generalSettings" */ "./generalSettings/index"),
      },
      {
        path: "countries",
        name: "platform.countries",
        component: () =>
          import(/* webpackChunkName: "platform.countries" */ "./transactionCountries"),
      },
      {
        path: "paymentTypes",
        name: "platform.paymentTypes",
        component: () => import(/* webpackChunkName: "platform.paymentTypes" */ "./paymentTypes"),
      },
      {
        path: "paymentProviders",
        name: "platform.paymentProviders",
        component: () =>
          import(/* webpackChunkName: "platform.paymentProviders" */ "./paymentProviders"),
      },
      {
        path: "cashInMethods",
        name: "platform.cashInMethods",
        component: () => import(/* webpackChunkName: "platform.cashInMethods" */ "./cashInMethods"),
      },
      {
        path: "cashoutMethods",
        name: "platform.cashoutMethods",
        component: () =>
          import(/* webpackChunkName: "platform.cashoutMethods" */ "./cashoutMethods"),
      },
      {
        path: "receivingCountries",
        name: "platform.receivingCountries",
        component: () =>
          import(/* webpackChunkName: "platform.receivingCountries" */ "./receivingCountries"),
      },
      {
        path: "feeTypes",
        name: "platform.feeTypes",
        component: () => import(/* webpackChunkName: "platform.feeTypes" */ "./feeTypes"),
      },
      {
        path: "roles",
        name: "platform.roles",
        component: () => import(/* webpackChunkName: "platform.roles" */ "./roles"),
      },
      {
        path: "staff",
        name: "platform.staff",
        component: () => import(/* webpackChunkName: "platform.roles" */ "./staff"),
      },
      {
        path: "activities",
        name: "platform.activities",
        component: () =>
          import(/* webpackChunkName: "platform.activities" */ "./individualActivities"),
      },
      {
        path: "revenuelevels",
        name: "platform.revenuelevels",
        component: () => import(/* webpackChunkName: "platform.revenuelevels" */ "./revenueLevels"),
      },
      {
        path: "currencies",
        name: "platform.currencies",
        component: () => import(/* webpackChunkName: "platform.currencies" */ "./currencies"),
      },
    ],
  },
];
